import { router } from '@inertiajs/react'
import { Badge } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'

// Header widget on the Top Down edit pages while editing a published plan:
// step progress plus a link to the submit page (Plan/TopDown/Submit), where
// the reviewers are picked and the changes are shown against the published
// version. Submitting there creates the revision task; afterwards
// PlanTaskWidget takes over, exactly as for a cycle task.
export default function RevisionSubmitWidget({ done, submitHref }: { done: number; submitHref: string }) {
  return (
    <div
      className="flex min-w-0 flex-col gap-0.5 rounded-lg border px-3 py-1.5"
      style={{ background: 'var(--background)', borderColor: 'var(--border)' }}
    >
      <div className="flex items-center gap-2">
        <Badge variant="info" className="px-1.5 py-0 text-[10px] whitespace-nowrap">Revision</Badge>
        <span className="whitespace-nowrap text-xs font-medium text-foreground">Editing the published plan</span>
      </div>
      <div className="flex items-center gap-2 text-[11px] text-muted-foreground">
        <span className="whitespace-nowrap">{done}/3 Done</span>
        <Button
          size="sm"
          className="ml-auto h-5 px-2 text-[11px]"
          disabled={done < 3}
          onClick={() => router.visit(submitHref)}
        >
          Submit for review
        </Button>
      </div>
    </div>
  )
}
